<script setup lang="ts">
import { toRef, ref } from "vue";
import { useField } from "vee-validate";
const props = defineProps({
  type: {
    type: String,
    default: "text",
  },
  value: {
    type: Number,
    default: 0,
  },
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  isRequired: {
    type: Number,
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  preEnteredEmail: {
    default: null,
    type: String,
  },
});

const emit = defineEmits(["focus"]);

// use `toRef` to create reactive references to `name` prop which is passed to `useField`
// this is important because vee-validte needs to know if the field name changes
// https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
const name = toRef(props, "name");
const checked = ref(props.value === 1 ? true : false);

// we don't provide any rules here because we are using form-level validation
// https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
  meta,
} = useField(name, undefined, {
  initialValue: props.value,
});

function whatClass() {
  if (meta.touched && meta.valid) {
    return "is-success";
  } else if (meta.touched && !meta.valid) {
    return "is-danger";
  } else {
    return "";
  }
}
</script>

<template>
  <span>
    <label class="checkbox">
      <input
        type="checkbox"
        v-model="checked"
        :name="name"
        :id="name"
        :class="`${whatClass()}`"
        @change="handleChange"
        @blur="handleBlur"
        @focus="$emit('focus')"
      />
      {{ props.label }}
    </label>

    <p
      :class="`is-size-7 ${
        errorMessage ? 'has-text-danger' : 'has-text-success'
      }`"
      v-show="errorMessage || meta.valid"
    >
      {{ errorMessage }}
    </p>
  </span>
</template>
